module.exports = __webpack_public_path__ + "static/media/admin.73f10e0f.png";